// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"717":"29b4b97d","990":"44528a07"}[chunkId] + ".chunk.js";
};